
import {addScript, getQueryString} from '@/commons/utils'
import md5 from './../../commons/md5.js'
import {fetch} from '@/commons/fetch'

var urls = {

  history: function (type) {
    var url = 'activityCenter/act_list.json'
    return getUrl(url)
  },
  list: '',
  result (id, type) {
    var url = 'activityCenter/act_' + id + '_' + (type || 'eia') + '_result.json'
    return getUrl(url)
  },
  current: (id, type) => {
    var url = 'activityCenter/act_' + id + '_' + (type || 'eia') + '_info.json'
    return getUrl(url)
  },
  vote: (type) => {
    if (type == 'eia') {
      return '//cdn.jin10.com/dc/reports/dc_eia_crude_oil_all.js?v=' + new Date().getTime()
    }

    return '//cdn.jin10.com/dc/reports/dc_nonfarm_payrolls_all.js?v=1520846001?v=' + new Date().getTime()
  },
  wechatCode (id) {
    return 'https://eia-api.jin10.com/getMyCode/' + id
  }

}

/// /jin10activity.oss-cn-hangzhou.aliyuncs.com/activityCenter/
var __domain = '//jingcai.jin10.com/'

var __apiDomain = 'https://eia-api.jin10.com/'

var getJSONPCallback = (url) => {
  // var path=url;

  // console.log(md5(url.replace(__domain, ""),false,false));
  var callbackName = 'JQ_' + md5(url.replace(__domain, ''), false, false)
  return callbackName
}

var getUrl = (path) => {
  return __domain + path
}
const getAjaxData = (url, params, onsuccess, jsonpCallback) => {
  window[jsonpCallback] = function (reponse) {
    // console.log(reponse);

    if (onsuccess) {
      onsuccess(reponse)
    }
  }
  //
  // console.log(jsonpCallback);
  let datas = []
  if (params && typeof params === 'object') {
    for (let key in params) {
      datas.push(key + '=' + params[key])
    }
    datas = datas.join('&')
  }

  var __url = url + '?' + datas

  addScript(__url, function () {

  })
}

const getJSON = (url, params, key, onsuccess, onfail) => {
  getAjaxData(url, params, onsuccess, key, onfail)
}
const getData = (url, params, onsuccess, onfail) => {
  fetch('get', params, url, onsuccess, onfail)
}
const postData = (url, params, onsuccess, onfail) => {
  fetch('post', params, url, onsuccess, onfail)
}

// initial state
const state = {
  histories: [],
  org: {},
  historyPage: 1,
  historyState: 'more',
  list: [],
  listState: 'more',
  current: {},
  result: [],
  voteList: [],
  voteType: '',
  myVote: '',
  activityDataType: '',
  activityType: '',
  pageTitle: '',
  wechatCode: {}
}

var getActivityType = () => {
  var __type = getQueryString('type')
  return (window.location.href.indexOf('feinong') > -1 || __type == 'feinong') ? 'fn' : 'eia'
}
// getters
const getters = {
  histories: state => state.histories,
  list: state => state.list,
  listState: state => state.listState,
  result: state => state.result,
  activityType: state => state.activityType,
  activityDataType: state => state.activityDataType,
  guess: state => state.current,
  voteList: state => state.voteList,
  voteType: state => state.voteType,
  myVote: state => state.myVote,
  pageTitle: state => state.pageTitle,
  wechatCode: state => state.wechatCode

}

// actions
const actions = {
  getHistories ({
    commit
  }, {

    onCompleted,
    currentPage,
    pageSize,
    isReload,
    itemId,
    activityType,
    onFilter
  }) {
    if (isReload) {
      state.histories.length = 0
      state.historyState = 'more'
      state.historyPage = 1
    } else {
      commit('getHistories', {
        data: state.org.history,
        onCompleted: onCompleted,
        onFilter
      })
    }

    // http://jin10xnews.oss-cn-hangzhou.aliyuncs.com/newsCenter/test/act_eia_list.json

    // console.log(url);

    var url = urls.history(activityType)

    getJSON(url, {
      v: new Date().getTime()
    }, getJSONPCallback(url), function (data) {
      state.org.history = data

      commit('getHistories', {
        data: state.org.history,
        onCompleted: onCompleted,
        itemId: itemId,
        activityType: activityType,
        onFilter
      })
    })
  },
  // 获取到获奖名单
  getResult ({
    commit
  }, {
    id,
    onCompleted,
    type
    // isPublish
  }) {
    state.result.length = 0
    var url = urls.result(id, type)
		// console.log(options.id);
    getJSON(url, {
      v: new Date().getTime()
    }, getJSONPCallback(url), (data) => {
      commit('getResult', {
        data: data,
        onCompleted: onCompleted
      })
    }, (error) => {}
    )
  },

  getWechatCode ({
    commit
  }, {
    id,
    onCompleted
    // isPublish
  }) {
    // console.log(3);
    // state.result.length = 0;
    var url = urls.wechatCode(id) + '?=' + (new Date()).getTime()

		// console.log(options.id);
    return new Promise((resolve, reject) => {
      fetch({
        type: 'get',
        params: {
        },
        url: url,
        success (response) {
          if (onCompleted) {
            onCompleted(response)
          }
          resolve(response)
        },
        fail (response) {
          reject(response)
        }

      })
    })

		// getJSON(url, {
		// 	v: new Date().getTime()
		// }, getJSONPCallback(url), (data) => {

		// 	commit('getWechatCode', {
		// 		data: data,
		// 		onCompleted: onCompleted
		// 	});

		// }, (error) => {}
     	// );
  },
  getList ({
    commit
  }, {
    id,
    onCompleted,
    currentPage,
    pageSize,
    isReload
  }) {
    if (isReload) {
      // state.histories.length = 0;
      // state.historyState = "more";
    }

    commit('getList', {
      data: state.list,
      onCompleted: onCompleted
    })
    return
    // console.log(options.id);
    getJSON(urls.list, {}, (data) => {
      var list = []
      data.map((item) => {
        var key = item[1]
        var avatar = '//cdn.jin10.com/avatar/' + key.substr(0, 2) + '/' + key + '/avatar.jpg'

        var _item = {
          nick: item[0],
          avatar: avatar,
          guess_value: item[1]
        }
				// console.log(_item);
        list.push(_item)
      })

      commit('getList', {
        data: list,
        onCompleted: onCompleted
      })
    }, (error) => {})
  },
  // 获取到当前值，预测值，公布值，前值
  getData ({
    commit
  }, {
    id,
    onCompleted,
    type,
    isPublish
  }) {
    // console.log(id);
    // http://jin10xnews.oss-cn-hangzhou.aliyuncs.com/newsCenter/test/act_178_eia_info.json
    var url = urls.current(id, type)

		// console.log(url);

    getJSON(url, {
      v: isPublish ? id : new Date().getTime()
    }, getJSONPCallback(url), function (data) {
      commit('getData', {
        data: data,
        onCompleted: onCompleted
      })
    })
  },
  // 获取到投票内容信息
  getVote ({
    commit
  }, {
    id,
    onCompleted,
    type
  }) {
    addScript(urls.vote(type), function () {
      // console.log('getVote');

      var data = (window.dataCenter_data || {})['list'] || {}

			// console.log(window.dataCenter_data);
      var type = ((window.dataCenter_data || {
        types: []
      })['types'][0]) || '' // types
			// console.log(data);
      commit('getVote', {
        data: data,
        onCompleted: onCompleted,
        type: type
      })
    })
  },
  // 提交竞猜
  submit ({
    commit
  }, {
    id,
    onCompleted,
    value,
    type
  }) {
    var url = __apiDomain + 'activity/join2/' + id // + "?type=" + type + "&value=" + value;

    return new Promise((resolve, reject) => {
      fetch({
        type: 'post',
        params: {
          type: type,
          value: value
        },
        url: url,
        success (response) {
          if (onCompleted) {
            onCompleted(response)
          }
          resolve(response)
        },
        fail (response) {
          reject(response)
        }

      })
    })
  }
}

// mutations
const mutations = {
  getHistories (state, {
    data,
    onCompleted,
    itemId,
    activityType,
    onFilter
  }) {
    // state.histories = state.org.history;

    var firstItem
    let _filter = (item) => {
      return (typeof onFilter === 'undefined' ? true : onFilter(item))
    }
    if (itemId) {
      var firstItems = state.org.history.filter(function (item) {
        return item.id == itemId && _filter(item)
      })
      state.histories = state.org.history.filter(function (item) {
        return item.type == firstItems[0].type && _filter(item)
      })
      firstItem = firstItems[0]
    } else if (activityType) {
      state.histories = state.org.history.filter(function (item) {
        return item.type == activityType && _filter(item)
      })

      firstItem = state.histories[0]
    } else {
      var firstItem = state.org.history[0]
      state.histories = state.org.history.filter(function (item) {
        return item.type == firstItem.type && _filter(item)
      })
    }

    // state.histories = state.histories.concat(data);
    if (onCompleted) {
      onCompleted(firstItem)
    }
  },

  setDataType (state, options) {
    state.activityDataType = options.type
    state.activityType = state.activityDataType == 'eia' ? 'eia' : 'fn'
    state.pageTitle = state.activityDataType == 'eia' ? '金十EIA - 金十数据' : '金十数据 -非农竞猜'
  },
  setMyVote (state, options) {
    state.myVote = options.value
  },
  getMyVote (state, options) {
    if (!options.userId || !options.guessList) {
      // state.myVote = '';
      return
    }
    var key = md5(options.userId + 'Jin十')
    var value = '';

    (options.guessList || []).map(function (item) {
      var _key = item[1]
      if (key == _key) {
        value = item[2]
      }
    })

    if (value != '') {
      state.myVote = value
    }

    return value
  },

  getResult (state, {
    data,
    onCompleted
  }) {
    state.result = data
    if (onCompleted) {
      onCompleted(data)
    }
  },
  getWechatCode (state, {
    data,
    onCompleted
  }) {
    state.wechatCode = data
    if (onCompleted) {
      onCompleted(data)
    }
  },
  getList (state, {
    data,
    onCompleted
  }) {
    state.list = state.list.concat(data)
    if (onCompleted) {
      onCompleted(data)
    }
  },
  getData (state, {
    data,
    onCompleted
  }) {
    // console.log(data);

    state.current = data
    if (onCompleted) {
      onCompleted(data)
    }
  },
  getVote (state, {
    data,
    onCompleted,
    type
  }) {
    state.voteList = data
    state.voteType = type

    if (onCompleted) {
      onCompleted(data)
    }
  },
  submit (state, {
    data,
    onCompleted
  }) {
    if (onCompleted) {
      onCompleted(data)
    }
  }

}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/guess.js